import { DateTime } from "luxon";

import {
  AnalyzeSitewideFrontendTinybirdRequestBodyType,
  DatasetId,
} from "@intelligems/ig-types";
import { getMaxZScore } from "@src/api/analytics/utils";
import { useConfiguration } from "@src/api/configurations/use-configuration";
import { useSelector } from "@src/store";
import { selectedSitewideDashboardFilters } from "@src/store/slices/sitewideDashboardFilters";

export const useBuildSitewideAnalyticsPayload = (): {
  build: (
    datasetId: DatasetId
  ) => AnalyzeSitewideFrontendTinybirdRequestBodyType;
} => {
  const maxZScore = useConfiguration<number>("max_z_score");
  const sitewideDashboardFilters = useSelector(
    selectedSitewideDashboardFilters
  );
  const {
    pageName,
    startTime,
    endTime,
    // hiddenEndTime,
    ...restOfDashboardFilters
  } = sitewideDashboardFilters;

  // TODO: Sitewide analytics - add filter for orders matched to session to payload
  return {
    build: (datasetId) => {
      return {
        ...restOfDashboardFilters,
        resourceType: "sitewide",
        endTs: !endTime
          ? endTime
          : typeof endTime === "string"
            ? endTime
            : DateTime.fromMillis(endTime).toISODate(),
        startTs: !startTime
          ? startTime
          : typeof startTime === "string"
            ? startTime
            : DateTime.fromMillis(startTime).toISODate(),
        landingPage: sitewideDashboardFilters.landingPage || null,
        sourceSitesOrChannels: sitewideDashboardFilters.channels,
        datasetId,
        maxZScore: getMaxZScore(
          sitewideDashboardFilters.maxZScore,
          sitewideDashboardFilters.isZScoreEnabled,
          maxZScore
        ),
        interval: sitewideDashboardFilters.interval,
      };
    },
  } as const;
};
